require('./release/angular-recaptcha.js');
module.exports = 'vcRecaptcha';



// WEBPACK FOOTER //
// ./node_modules/angular-recaptcha/index.js